import React, { Component } from "react";
import * as Constants from "../../Constants/index";
import axios from "axios";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import Modal from 'react-modal';

import '../../pages/modal/modal.style.css';

class ProgramTickets extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
  }

  state = {
    name: "",
    sortBy: "type",
    limit: 25,
    totalResults: 0,
    page: 1,
    members: [],
    search: "",
    create: 0,
    view: 0,
    verifyModal: false,
    viewDescription: false,
    description: "",
    status: "",
    remarks: "",
    reason: "",
    ticketID: 0,
    showImageModal: false,
    selectedImage: "",
  };

  componentDidMount() {
    const currentURL = window.location.pathname;
    const parts = currentURL.split("/");
    let programid = parts.pop();
    programid = parseInt(programid);
    const pathSegments = window.location.pathname.split('/');
    let compid = pathSegments[pathSegments.length - 2];
    const memberRequest = async () => {
      try {
        const token = localStorage.getItem("token");
        let url = "";
        this.state.search !== ""
          ? (url =
            "program/child/ticket?sortAsc=true&" +
            "searchTerm=" +
            this.state.search +
            "&sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page)
          : (url =
            "program/child/ticket?sortAsc=true&sortBy=" +
            this.state.sortBy +
            "&limit=" +
            this.state.limit +
            "&page=" +
            this.state.page);
        const resp = await axios
          .get(Constants.api + url, {
            headers: {
              Authorization: `Bearer ${token}`,
              company: compid,
              program: programid,
              appVersion: Constants.av,
              platform: Constants.pt
            },
          })
          .then((resp) => {
            if (resp.status == 201 && resp.data.result !== "error") {
              const results = Array.isArray(resp.data.output.results)
                ? resp.data.output.results
                : [];
              this.setState({
                members: results,
                totalResults: resp.data.output.totalResults
              });
              console.log(this.state.tiers);
            } else if (
              resp.data.code === 12002 ||
              resp.data.output?.results === null
            ) {
              this.setState({
                members: [],
                totalResults: 0,
              });
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
          }).catch((err) => {
            console.error(err);
          });
      } catch (err) {
        console.error(err);
      }
    };
    memberRequest();
  }

  handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  searchHandleChange = (event) => {
    this.setState(
      { search: event.target.value, page: 1 },
      this.componentDidMount
    );
  };

  handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    this.setState({ page: pageNumber }, this.componentDidMount);
  }

  handleOpenImageModal = (url) => {
    this.setState({
      showImageModal: true,
      selectedImage: url,
    });
  };

  handleCloseImageModal = () => {
    this.setState({
      showImageModal: false,
      selectedImage: "",
    });
  };

  render() {
    const closeTicket = (id) => {
      try {
        const token = localStorage.getItem("token");
        const currentURL = window.location.pathname;
        const parts = currentURL.split("/");
        let programid = parts.pop();
        programid = parseInt(programid);
        axios
          .patch(
            Constants.api + "program/child/ticket/" + id, {
            status: this.state.status,
            adminRemarks: this.state.remarks,
            action: "STATUS_UPDATE"
          },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                program: programid,
                "Accept-Language": localStorage.getItem("language"),
                appVersion: Constants.av,
                platform: Constants.pt
              },
            },
          )
          .then((resp) => {
            swal("Status Updated")
            if (resp.status == 200) {
              this.setState({ verifyModal: false }, this.componentDidMount());
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            } else {
            }
          }).catch((err) => {
            console.error(err);
          });
      } catch (err) {
        console.error(err);
      }
    };

    const editItem = (id) => {
      try {
        const token = localStorage.getItem("token");
        const deletedata = new FormData();
        deletedata.append("id", id);
        axios
          .get(
            Constants.api + "program/child/ticket/" + id,
            {
              headers: { Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("language") },
            },
            deletedata
          )
          .then((resp) => {
            if (resp.status == 200) {
              this.setState({ create: 1, resp: resp });
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            }
          }).catch((err) => {
            console.error(err);
          });
      } catch (err) {
        console.error(err);
      }
    };

    const viewItem = (id) => {
      try {
        const token = localStorage.getItem("token");
        const deletedata = new FormData();
        deletedata.append("id", id);
        axios
          .get(
            Constants.api + "program/child/ticket/" + id,
            {
              headers: { Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("language") },
            },
            deletedata
          )
          .then((resp) => {
            if (resp.status == 200) {
              this.setState({ view: 1, create: 1, resp: resp });
            } else if (resp.status == 403) {
              localStorage.clear();
              window.location.href = "/";
            }
          }).catch((err) => {
            console.error(err);
          });
      } catch (err) {
        console.error(err);
      }
    };

    const deleteItem = (id) => {
      if (window.confirm("Are you sure?")) {
        try {
          const token = localStorage.getItem("token");
          const deletedata = new FormData();
          deletedata.append("id", id);
          axios
            .delete(
              Constants.api + "program/child/ticket/" + id,
              {
                headers: { Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("language") },
              }
            )
            .then((resp) => {
              if (resp.status == 200) {
                this.componentDidMount();
              } else if (resp.status == 403) {
                localStorage.clear();
                window.location.href = "/";
              }
            });
        } catch (err) {
          console.error(err);
        }
      }
    };

    let verifyModal = (id) => {
      this.setState({ verifyModal: !this.state.verifyModal, ticketID: id })
    }

    let viewDescriptions = (description, id) => {
      this.setState({ viewDescription: !this.state.viewDescription, description: description, ticketID: id })
    }

    let viewDescription = this.state.viewDescription;
    let description = this.state.description;
    let ticketID = this.state.ticketID;

    // ✅ FIX: Changed from `function(item, i)` to an arrow function `(item, i) =>`
    // so that `this` correctly refers to the component instance
    const members = Array.isArray(this.state.members) ? this.state.members : [];

    const membersRender = members.length === 0 ? (
      <tr>
        <td colSpan="9" className="text-center py-4">
          No record found
        </td>
      </tr>
    ) : members.map((item, i) => {
      return (
        <>
          <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.userName}</td>
            <td>{item.userMobile}</td>
            <td><p>{item.type}</p></td>

            <td>
              {ticketID == item.id ?
                <p>{viewDescription ? description : item.description.substr(0, 30) + "..."}
                  <small>
                    <a onClick={() => viewDescriptions(item.description, item.id)}>
                      <i className="material-icons text-lg">visibility</i>
                    </a>
                  </small>
                </p>
                :
                <p>{item.description.substr(0, 30)}...
                  <small>
                    <a onClick={() => viewDescriptions(item.description, item.id)}>
                      <i className="material-icons text-lg">visibility</i>
                    </a>
                  </small>
                </p>
              }
            </td>

            <td>
              {/* ✅ Now works correctly because `this` is properly bound via arrow function */}
              <button
                className="btn btn-sm btn-info"
                onClick={() => this.handleOpenImageModal(item.ticketImg)}
              >
                View
              </button>
            </td>

            <td className="date_two">
              <p>{item.status}</p>
            </td>

            <td className="date_two">
              {item.createdDateTime}
            </td>

            <td>
              {item.status == 'OPEN' ?
                <button className="btn btn-outline-primary btn-sm" onClick={() => verifyModal(item.id)}>
                  <i className="material-icons text-lg">check_circle</i> Resolve
                </button> :
                <button className="btn btn-outline-warning btn-sm" onClick={() => verifyModal(item.id)}>
                  <i className="material-icons text-lg">check_circle</i> Reopen
                </button>
              }
              &nbsp;
            </td>
          </tr>
        </>
      );
    });

    return (
      <>
        {this.state.create == 0 ? (
          <>
            <main className="">
              <nav className="navbar navbar-main navbar-expand-lg position-sticky mt-4 top-1 px-0 mx-4 shadow-none border-radius-xl z-index-sticky" id="navbarBlur" data-scroll="true">
                <div className="container-fluid py-1 px-3">
                  <nav aria-label="breadcrumb"></nav>
                  <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                    <a className="nav-link text-body p-0">
                      <div className="sidenav-toggler-inner">
                        <i className="sidenav-toggler-line"></i>
                        <i className="sidenav-toggler-line"></i>
                        <i className="sidenav-toggler-line"></i>
                      </div>
                    </a>
                  </div>
                  <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                    <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                      <div className="input-group input-group-outline">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          onChange={this.searchHandleChange}
                        />
                      </div>
                    </div>
                    <ul className="navbar-nav justify-content-end">
                      <li className="nav-item">
                        <div className="from_dropdown">
                          <label htmlFor="show">Show entries</label>
                          <select name="cars" id="show">
                            <option value="25" onClick={(() => this.setState({ limit: 25 }), () => this.componentDidMount())}>25</option>
                            <option value="50" onClick={(() => this.setState({ limit: 50 }), () => this.componentDidMount())}>50</option>
                            <option value="75" onClick={(() => this.setState({ limit: 75 }), () => this.componentDidMount())}>75</option>
                            <option value="100" onClick={(() => this.setState({ limit: 100 }), () => this.componentDidMount())}>100</option>
                          </select>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>

              <div className="container-fluid py-4">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header pb-0">
                        <div className="d-lg-flex">
                          <div>
                            <h5 className="mb-0">All Program Tickets</h5>
                          </div>
                          <div className="ms-auto my-auto mt-lg-0 mt-4">
                            <div className="ms-auto my-auto">

                              {this.state.verifyModal &&
                                <Modal
                                  isOpen={this.state.verifyModal}
                                  onRequestClose={() => this.setState({ verifyModal: false })}
                                  className="custom-modal"
                                  overlayClassName="custom-modal-overlay"
                                >
                                  <center>
                                    <div className="row">
                                      <div className="col-sm-12">
                                        <div className="mx-4 input-group-outline my-2">Status</div>
                                        <div className="mx-4 input-group-outline my-2">
                                          <select
                                            value={this.state.status}
                                            name="status"
                                            className="form-control"
                                            onChange={(e) => this.handleInputChange(e)}
                                          >
                                            <option value="">Select</option>
                                            <option value="OPEN">OPEN</option>
                                            <option value="CLOSED">CLOSED</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-sm-12">
                                        <div className="mx-4 input-group-outline my-2">Remarks</div>
                                        <div className="mx-4 input-group-outline my-2">
                                          <textarea
                                            className="form-control"
                                            name="remarks"
                                            onChange={(e) => this.handleInputChange(e)}
                                          >
                                            {this.state.remarks}
                                          </textarea>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-sm-12">
                                        <a href="#!" className="btn bg-gradient-default mb-2" onClick={() => verifyModal(this.state.ticketID)}>Cancel</a>
                                        &nbsp;
                                        <a href="#!" className="btn bg-gradient-primary mb-2" onClick={() => closeTicket(this.state.ticketID)}>Save Status</a>
                                      </div>
                                    </div>
                                  </center>
                                </Modal>
                              }

                              <Modal
                                isOpen={this.state.showImageModal}
                                onRequestClose={this.handleCloseImageModal}
                                className="custom-modal"
                                overlayClassName="custom-modal-overlay"
                              >
                                <center>
                                  <h5>Image Preview</h5>
                                  <img
                                    src={this.state.selectedImage}
                                    style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }}
                                    alt="Ticket"
                                  />
                                  <br /><br />
                                  <button className="btn btn-secondary" onClick={this.handleCloseImageModal}>
                                    Close
                                  </button>
                                </center>
                              </Modal>

                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-flush">
                            <thead className="thead-light">
                              <tr>
                                <th>Ticket ID</th>
                                <th>Member Name</th>
                                <th>Member Mobile</th>
                                <th>Type</th>
                                <th width="20%">Description</th>
                                <th>Ticket Image</th>
                                <th>Status</th>
                                <th>Created On</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {membersRender}
                            </tbody>
                          </table>

                          {this.state.totalResults > 0 ? (
                            <div className="pagination-container">
                              <Pagination
                                activePage={this.state.page}
                                itemsCountPerPage={this.state.limit}
                                totalItemsCount={this.state.totalResults}
                                pageRangeDisplayed={20}
                                onChange={this.handlePageChange.bind(this)}
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </>
        ) : ''}
      </>
    );
  }
}

export default ProgramTickets;
